/** Laufzeitkonfiguration aus Vite-ENV (nur öffentliche Werte, keine Secrets). */
const e = import.meta.env;

export type AuthMode = 'msal' | 'dev';

const mock = e.VITE_API_MOCK === '1' || e.VITE_API_MOCK === 'true';

export const env = {
  mock,
  authMode: (mock ? 'dev' : e.VITE_AUTH_MODE === 'dev' ? 'dev' : 'msal') as AuthMode,
  devUsers: String(e.VITE_DEV_USERS || 'admin@autopilot.local,operator@autopilot.local,operator2@autopilot.local,viewer@autopilot.local,noscope@autopilot.local,norole@autopilot.local')
    .split(',')
    .map((s: string) => s.trim())
    .filter(Boolean),
  entraClientId: String(e.VITE_ENTRA_CLIENT_ID || ''),
  entraTenantId: String(e.VITE_ENTRA_TENANT_ID || ''),
  apiScope: String(e.VITE_API_SCOPE || ''),
  apiBase: String(e.VITE_API_BASE || '/api/v1'),
};
